var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.filters.length)?_c('div',{staticClass:"body-2 no-filters"},[_vm._v("None")]):_vm._l((_vm.filters),function(filter){return _c('div',{staticClass:"caption mb-2 filter"},[_c('div',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.toLabel(filter)))]),_c('span',[_vm._v(_vm._s(_vm.toLabelValue(filter)))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }